import React from 'react'

class FileList extends React.Component {
  renderFiles() {
    return this.props.files.map((file, index) => {
      return (
        <li key={`guest-upload-file${index}`} className='guest-upload-file'>
          <i className='fa fa-times-circle no-select' onClick={() => {this.props.removeFile(index)} } />
          <p className='guest-upload-filename'>{file.filename}</p>
          <img src={file.url} className='guest-upload-file-preview no-select'/>
        </li>
      )
    })
  }

  render() {
    return (
      <ul className='guest-upload-files'>
        {this.renderFiles()}
      </ul>
    )
  }
}

export default FileList;
